import { render, staticRenderFns } from "./aCarDetailHis.vue?vue&type=template&id=7b604059&scoped=true"
import script from "./aCarDetailHis.vue?vue&type=script&lang=js"
export * from "./aCarDetailHis.vue?vue&type=script&lang=js"
import style0 from "./aCarDetailHis.vue?vue&type=style&index=0&id=7b604059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b604059",
  null
  
)

export default component.exports